import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param client
 * @param query If `undefined`, no data is fetched
 * @returns If no result, `connection` is `undefined`.
 */
export function useAdminEntitiesTotalCount(client, query) {
    const fetcher = useCallback(([_action, query]) => fetchEntitiesTotalCount(client, query), [client]);
    const { data: totalCount, error: totalCountError } = useSWR(query ? CACHE_KEYS.adminEntitiesTotalCount(query) : null, fetcher);
    // useDebugLogChangedValues('useAdminEntitiesTotalCount updated values', { client, query, totalCount, totalCountError, });
    return { totalCount, totalCountError };
}
async function fetchEntitiesTotalCount(client, query) {
    const result = await client.getEntitiesTotalCount(query);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminEntitiesTotalCount.js.map